"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.Connection = void 0;
var graphql_request_1 = require("graphql-request");
var Connection = /** @class */ (function () {
    function Connection(sdk) {
        this.sdk = sdk;
    }
    Connection.prototype.get = function (connectionAccount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.program.account.connection.fetch(connectionAccount)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Connection.prototype.create = function (fromProfile, toProfile, userAccount, owner) {
        return __awaiter(this, void 0, void 0, function () {
            var instructionMethodBuilder, pubKeys, connectionPDA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instructionMethodBuilder = this.sdk.program.methods
                            .createConnection()
                            .accounts({
                            fromProfile: fromProfile,
                            toProfile: toProfile,
                            user: userAccount,
                            authority: owner
                        });
                        return [4 /*yield*/, instructionMethodBuilder.pubkeys()];
                    case 1:
                        pubKeys = _a.sent();
                        connectionPDA = pubKeys.connection;
                        return [2 /*return*/, {
                                instructionMethodBuilder: instructionMethodBuilder,
                                connectionPDA: connectionPDA
                            }];
                }
            });
        });
    };
    Connection.prototype["delete"] = function (connectionAccount, fromProfile, toProfile, userAccount, owner) {
        return this.sdk.program.methods
            .deleteConnection()
            .accounts({
            connection: connectionAccount,
            fromProfile: fromProfile,
            toProfile: toProfile,
            user: userAccount,
            authority: owner
        });
    };
    // GraphQL Query methods
    Connection.prototype.getAllConnections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query GetAllConnections {\n      gum_0_1_0_decoded_connection {\n        toprofile\n        fromprofile\n        cl_pubkey\n      }\n    "], ["\n      query GetAllConnections {\n      gum_0_1_0_decoded_connection {\n        toprofile\n        fromprofile\n        cl_pubkey\n      }\n    "])));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.gum_0_1_0_decoded_connection];
                }
            });
        });
    };
    Connection.prototype.getConnectionsByUser = function (userPubKey) {
        return __awaiter(this, void 0, void 0, function () {
            var profiles, profilePDAs, query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.profile.getProfilesByUser(userPubKey)];
                    case 1:
                        profiles = _a.sent();
                        profilePDAs = profiles.map(function (p) { return p.cl_pubkey; });
                        query = (0, graphql_request_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      query GetConnectionsByUser {\n        gum_0_1_0_decoded_connection(where: {fromprofile: {_in: [", "] }}) {\n          fromprofile\n          toprofile\n          cl_pubkey\n        }\n      }\n    "], ["\n      query GetConnectionsByUser {\n        gum_0_1_0_decoded_connection(where: {fromprofile: {_in: [", "] }}) {\n          fromprofile\n          toprofile\n          cl_pubkey\n        }\n      }\n    "])), profilePDAs.map(function (pda) { return "\"".concat(pda, "\""); }).join(","));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.gum_0_1_0_decoded_connection];
                }
            });
        });
    };
    Connection.prototype.getFollowersByProfile = function (profileAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, result, followers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = (0, graphql_request_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      query GetFollowersByProfile ($profileAccount: String!) {\n        gum_0_1_0_decoded_connection(where: {toprofile: {_eq: $profileAccount}}) {\n          fromprofile\n        }\n      }"], ["\n      query GetFollowersByProfile ($profileAccount: String!) {\n        gum_0_1_0_decoded_connection(where: {toprofile: {_eq: $profileAccount}}) {\n          fromprofile\n        }\n      }"])));
                        variables = {
                            profileAccount: profileAccount.toBase58()
                        };
                        return [4 /*yield*/, this.sdk.gqlClient.request(query, variables)];
                    case 1:
                        result = _a.sent();
                        followers = result.gum_0_1_0_decoded_connection.map(function (follower) { return follower.fromprofile; });
                        return [2 /*return*/, followers];
                }
            });
        });
    };
    Connection.prototype.getFollowingsByProfile = function (profileAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, result, followings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = (0, graphql_request_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      query GetFollowingsByProfile ($profileAccount: String!) {\n        gum_0_1_0_decoded_connection(where: {fromprofile: {_eq: $profileAccount}}) {\n          toprofile\n        }\n      }\n    "], ["\n      query GetFollowingsByProfile ($profileAccount: String!) {\n        gum_0_1_0_decoded_connection(where: {fromprofile: {_eq: $profileAccount}}) {\n          toprofile\n        }\n      }\n    "])));
                        variables = {
                            profileAccount: profileAccount.toBase58()
                        };
                        return [4 /*yield*/, this.sdk.gqlClient.request(query, variables)];
                    case 1:
                        result = _a.sent();
                        followings = result.gum_0_1_0_decoded_connection.map(function (following) { return following.toprofile; });
                        return [2 /*return*/, followings];
                }
            });
        });
    };
    return Connection;
}());
exports.Connection = Connection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
